import React, { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import axios from "axios";
import { API_ENDPOINTS } from "../config/api";  //  Use API_ENDPOINTS

const InvoiceGenerator = () => {
  const { subscriptionId } = useParams();
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchInvoiceData();
  }, [subscriptionId]);  // ✅ Add dependency

  const fetchInvoiceData = async () => {
    try {
      const token = localStorage.getItem('token') || new URLSearchParams(window.location.search).get('token');
      
      console.log('🔍 INVOICE DEBUG:', { subscriptionId, hasToken: !!token });
      
      if (!token) {
        alert('No auth token');
        navigate('/subscribe');
        return;
      }
      
      const response = await axios.get(API_ENDPOINTS.invoice(subscriptionId), {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      setInvoiceData(response.data.invoice);
      setLoading(false);
    } catch (error) {
      console.error('❌ ERROR:', error.response?.data);
      alert(`Failed: ${error.response?.data?.error || 'Subscription not found'}`);
      setLoading(false);
    }
  };



  const handlePrint = useReactToPrint({
    contentRef: componentRef,  // Updated for v3.x
    documentTitle: `Invoice-${invoiceData?.invoiceNumber}`,
    pageStyle: `
      @page {
        size: A4;
        margin: 20mm;
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
      }
    `
  });

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "50px", fontFamily: "'Metropolis','Helvetica Neue',Arial,sans-serif" }}>
        Loading invoice...
      </div>
    );
  }

  if (!invoiceData) {
    return (
      <div style={{ textAlign: "center", padding: "50px", color: "#dc3545", fontFamily: "'Metropolis','Helvetica Neue',Arial,sans-serif" }}>
        Invoice not found
      </div>
    );
  }

  return (
    <div style={{ margin: 0, padding: 0, background: "#f9fafc", minHeight: "100vh" }}>
{/* Print Buttons */}
<div className="no-print" style={{ 
  textAlign: "center", 
  padding: "20px", 
  background: "#fff", 
  borderBottom: "1px solid #e1e8ed",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px"
}}>
  <button 
    onClick={() => navigate(-1)} 
    style={{ 
      padding: "12px 24px", 
      background: "#6c757d", 
      color: "#fff", 
      border: "none", 
      borderRadius: "6px", 
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "600",
      fontFamily: "'Metropolis','Helvetica Neue',Arial,sans-serif"
    }}
  >
    Back
  </button>
  <button 
    onClick={handlePrint}
    style={{ 
      padding: "12px 24px", 
      background: "linear-gradient(135deg,#007bff,#0056d2)", 
      color: "#fff", 
      border: "none", 
      borderRadius: "6px", 
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "600",
      fontFamily: "'Metropolis','Helvetica Neue',Arial,sans-serif"
    }}
  >
    Print Invoice
  </button>
</div>

      {/* Invoice Content - Printable */}
      <div ref={componentRef} style={{ 
        background: "#ffffff", 
        maxWidth: "800px", 
        margin: "40px auto",
        padding: "60px",
        boxShadow: "0 0 20px rgba(0,0,0,0.1)",
        fontFamily: "'Metropolis','Helvetica Neue',Arial,sans-serif"
      }}>
        {/* Header */}
        <div style={{ 
          background: "linear-gradient(135deg,#007bff,#0056d2)", 
          padding: "30px",
          borderRadius: "8px",
          textAlign: "center",
          marginBottom: "40px"
        }}>
          {/*  Public folder se image load karo */}
          <img 
            src={process.env.PUBLIC_URL + "/hola.png"}
            alt="Hola Logo" 
            width="40" 
            style={{ marginBottom: "10px" }}
          />
          <h1 style={{ 
            margin: 0, 
            fontSize: "28px", 
            fontWeight: 700, 
            color: "#ffffff"
          }}>
            Hola!...Speaking..
          </h1>
          <p style={{ 
            margin: "8px 0 0", 
            fontSize: "14px", 
            color: "#e3f2fd"
          }}>
            SUBSCRIPTION INVOICE
          </p>
        </div>

        {/* Invoice Info Section */}
        <div style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          marginBottom: "40px",
          flexWrap: "wrap",
          gap: "20px"
        }}>
          <div>
            <h2 style={{ 
              margin: "0 0 8px", 
              fontSize: "22px", 
              fontWeight: 700, 
              color: "#007bff"
            }}>
              INVOICE
            </h2>
            <p style={{ margin: "4px 0", fontSize: "14px", color: "#666" }}>
              <strong>Invoice #:</strong> {invoiceData.invoiceNumber}
            </p>
            <p style={{ margin: "4px 0", fontSize: "14px", color: "#666" }}>
              <strong>Date:</strong> {invoiceData.createdDate}
            </p>
          </div>
          <div style={{ textAlign: "right" }}>
            <h3 style={{ 
              margin: "0 0 8px", 
              fontSize: "16px", 
              fontWeight: 600, 
              color: "#333"
            }}>
              Bill To:
            </h3>
            <p style={{ margin: "4px 0", fontSize: "14px", color: "#555" }}>
              <strong>{invoiceData.customerName}</strong>
            </p>
            <p style={{ margin: "4px 0", fontSize: "14px", color: "#555" }}>
              {invoiceData.customerEmail}
            </p>
          </div>
        </div>

        {/* Invoice Table */}
        <div style={{ 
          border: "1px solid #e1e8ed", 
          borderRadius: "8px", 
          overflow: "hidden",
          marginBottom: "30px"
        }}>
          <div style={{ 
            background: "#f8fafc", 
            display: "grid",
            gridTemplateColumns: "2fr 1fr 1fr",
            padding: "16px",
            borderBottom: "2px solid #e1e8ed"
          }}>
            <div style={{ fontWeight: 600, fontSize: "14px", color: "#333" }}>
              Plan Details
            </div>
            <div style={{ fontWeight: 600, fontSize: "14px", color: "#333", textAlign: "center" }}>
              Amount
            </div>
            <div style={{ fontWeight: 600, fontSize: "14px", color: "#333", textAlign: "center" }}>
              Status
            </div>
          </div>
          <div style={{ 
            display: "grid",
            gridTemplateColumns: "2fr 1fr 1fr",
            padding: "20px 16px",
            alignItems: "center"
          }}>
            <div>
              <strong style={{ fontSize: "15px", color: "#555" }}>
                {invoiceData.planName}
              </strong>
              <br />
              <small style={{ color: "#888" }}>Monthly Subscription</small>
            </div>
            <div style={{ 
              textAlign: "center", 
              fontSize: "18px", 
              fontWeight: 700, 
              color: "#007bff"
            }}>
              ${invoiceData.amount}
            </div>
            <div style={{ textAlign: "center" }}>
              <span style={{ 
                display: "inline-block",
                padding: "6px 12px", 
                borderRadius: "20px", 
                fontSize: "12px", 
                fontWeight: 600,
                textTransform: "uppercase",
                background: invoiceData.status === "active" ? "#0057D4" : "#0CB0FF",
                color: invoiceData.status === "active" ? "#ffffffff" : "#ffffffff"
              }}>
                {invoiceData.status}
              </span>
            </div>
          </div>
        </div>

        {/* Next Billing Info */}
        <div style={{ 
          padding: "16px", 
          background: "#e7f3ff", 
          border: "1px solid #b3d9ff", 
          borderRadius: "8px", 
          marginBottom: "30px"
        }}>
          <h4 style={{ 
            margin: "0 0 8px", 
            fontSize: "16px", 
            fontWeight: 600, 
            color: "#004085"
          }}>
             Next Billing Date
          </h4>
          <p style={{ margin: 0, fontSize: "14px", color: "#004085" }}>
            Your next payment is scheduled for <strong>{invoiceData.nextBillingDate}</strong>
          </p>
        </div>
                
        {/* Thank You Message */}
        <div style={{ 
          textAlign: "center", 
          padding: "20px", 
          background: "#f8fafc", 
          borderRadius: "8px",
          marginBottom: "30px"
        }}>
          <h3 style={{ 
            margin: "0 0 8px", 
            fontSize: "18px", 
            fontWeight: 600, 
            color: "#0061E0"
          }}>
            Thank you for your business!
          </h3>
<p style={{ margin: "8px 0 0", fontSize: "14px", color: "#666" }}>
  Support: <a 
    href="mailto:brianwhistler@gmail.com" 
    style={{ color: "#007bff", textDecoration: "none" }}
  >
    brianwhistler@gmail.com
  </a> | Visit: <a 
    href="https://holaspeaking.ca/" 
    target="_blank" 
    rel="noopener noreferrer"
    style={{ color: "#007bff", textDecoration: "none" }}
  >
    holaspeaking.ca
  </a>
</p>

        </div>

        {/* Footer */}
        <div style={{ 
          textAlign: "center", 
          paddingTop: "20px", 
          borderTop: "1px solid #e1e8ed"
        }}>
          <p style={{ margin: 0, fontSize: "12px", color: "#999" }}>
            © {new Date().getFullYear()} Hola App. All rights reserved.
          </p>
          <p style={{ margin: "5px 0 0", fontSize: "12px", color: "#999" }}>
            You're receiving this invoice for your active subscription.
          </p>
        </div>
      </div>

      <style>{`
        @media print {
          .no-print {
            display: none !important;
          }
          
          body {
            margin: 0;
            padding: 0;
            background: white !important;
          }
          
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        }
      `}</style>
    </div>
  );
};

export default InvoiceGenerator;
